import { render, staticRenderFns } from "./ColourMatchToolNotice.vue?vue&type=template&id=d5b7c6c0&scoped=true&"
import script from "./ColourMatchToolNotice.vue?vue&type=script&lang=js&"
export * from "./ColourMatchToolNotice.vue?vue&type=script&lang=js&"
import style0 from "./ColourMatchToolNotice.vue?vue&type=style&index=0&id=d5b7c6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b7c6c0",
  null
  
)

export default component.exports